import { gray4 } from "assets/styleUtils";
import { TFormType } from "data/company";
import moment from "moment";
import { useEffect, useState } from "react";
import { TInputsData } from "./EtcInsertEntryInfoPage";
import styles from "./style.module.css";

export function ExtraDataInputView({
  setExtraData,
  companyFormData,
}: {
  setExtraData: React.Dispatch<React.SetStateAction<TInputsData[]>>;
  companyFormData?: TFormType[];
}) {
  const [paramsCompanyFormData, setPramsCompanyFormData] = useState(
    companyFormData || [],
  );
  const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");

  const checkToBeforeToday = (e: React.ChangeEvent<HTMLInputElement>) => {
    const today = moment();
    if (e.target.type === "date") {
      const selectedDate = moment(e.target.value).startOf("day");

      if (selectedDate.isSameOrBefore(today, "day")) {
        e.target.value = "";
        return;
      }
    }
  };
  const selectMultiItem = ({
    title,
    item,
  }: {
    title: string;
    item: string;
  }) => {
    setPramsCompanyFormData((prevParams) => {
      const newParams = prevParams.map((prev) => {
        const contentArray = prev.content?.split(",") || [];
        const itemExists = contentArray.includes(item);
        if (title === prev.title) {
          let updatedContent;
          if (itemExists) {
            updatedContent = contentArray
              .filter((data) => data !== item)
              .join(",");
          } else {
            updatedContent = prev.content ? `${prev.content},${item}` : item;
          }
          return {
            ...prev,
            content: updatedContent,
          };
        } else {
          return prev;
        }
      });

      return newParams;
    });
  };

  const updateFormData = ({
    value,
    formTitle,
    index,
  }: {
    value: string;
    formTitle: string;
    index: number;
  }) => {
    setPramsCompanyFormData((prev) =>
      prev.map((prevItem, prevIndex) => {
        const updatedCheckObject = (prevItem.checkObject || []).map((objItem) =>
          prevItem.content === objItem.form_title
            ? { ...objItem, form_content: value }
            : objItem,
        );

        return prevIndex === index
          ? {
              ...prevItem,
              content: formTitle + "," + value,
              checkObject: updatedCheckObject,
            }
          : {
              ...prevItem,
              checkObject: updatedCheckObject,
            };
      }),
    );
  };

  useEffect(() => {
    if (companyFormData) {
      setPramsCompanyFormData(companyFormData);
    }
  }, [companyFormData]);

  useEffect(() => {
    if (paramsCompanyFormData) {
      const newData: TInputsData[] = paramsCompanyFormData.map((formData) => ({
        title: formData.title,
        content: formData.content || "",
        require: formData.required_yn,
        dataType: formData.type,
        admin_note: formData.admin_note,
      }));

      setExtraData(newData);
    }
  }, [paramsCompanyFormData]);
  return (
    <>
      {(paramsCompanyFormData || []).map((item, index) => {
        return (
          <div key={index}>
            <div className={styles.titleStyle}>
              {item.title} {item.required_yn === "Y" && "*"}
            </div>
            {item.subTitle && (
              <>
                <div
                  style={{
                    fontWeight: "500",
                    lineHeight: "15px",
                    color: gray4,
                    marginTop: "10px",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {item.subTitle}
                </div>
              </>
            )}
            {item.type === "string" && (
              <input
                type="text"
                style={{ marginTop: "10px" }}
                className={styles.commonInput}
                placeholder={item.placeholder}
                onChange={(e) =>
                  setPramsCompanyFormData((prev) =>
                    prev.map((prevItem, prevIndex) =>
                      prevIndex === index
                        ? {
                            ...prevItem,
                            content: e.target.value,
                          }
                        : prevItem,
                    ),
                  )
                }
              />
            )}
            {item.type === "date" && (
              <input
                type="date"
                style={{ marginTop: "10px" }}
                className={styles.commonInput}
                min={tomorrow}
                onChange={(e) => {
                  checkToBeforeToday(e);
                  setPramsCompanyFormData((prev) =>
                    prev.map((prevItem, prevIndex) =>
                      prevIndex === index
                        ? {
                            ...prevItem,
                            content: e.target.value,
                          }
                        : prevItem,
                    ),
                  );
                }}
              />
            )}
            {item.type === "number" && (
              <input
                type="text"
                style={{ marginTop: "10px" }}
                className={styles.commonInput}
                onChange={(e) =>
                  setPramsCompanyFormData((prev) =>
                    prev.map((prevItem, prevIndex) =>
                      prevIndex === index
                        ? {
                            ...prevItem,
                            content: e.target.value,
                          }
                        : prevItem,
                    ),
                  )
                }
              />
            )}
            {item.type === "time" && (
              <input
                type="time"
                style={{ marginTop: "10px" }}
                className={styles.commonInput}
                onChange={(e) =>
                  setPramsCompanyFormData((prev) =>
                    prev.map((prevItem, prevIndex) =>
                      prevIndex === index
                        ? {
                            ...prevItem,
                            content: e.target.value,
                          }
                        : prevItem,
                    ),
                  )
                }
              />
            )}

            {item.type === "checkbox" && (
              <div style={{ marginTop: "10px" }}>
                {(item.checklist || []).map((checkData, checkIndex) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                      }}
                      key={checkIndex}
                    >
                      <div className={styles.radio}>
                        <input
                          type="checkbox"
                          onClick={() => {
                            setPramsCompanyFormData((prev) =>
                              prev.map((prevItem, prevIndex) =>
                                prevIndex === index
                                  ? {
                                      ...prevItem,
                                      content: checkData,
                                    }
                                  : prevItem,
                              ),
                            );
                          }}
                          checked={item.content === checkData}
                          readOnly
                        />
                        <span />
                      </div>
                      <div style={{ marginLeft: "10px" }}>{checkData}</div>
                    </div>
                  );
                })}
              </div>
            )}
            {item.type === "multiCheckbox" && (
              <div style={{ marginTop: "10px" }}>
                {(item.checklist || []).map((checkData, checkIndex) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                      }}
                      key={checkIndex}
                    >
                      <div className={styles.checkbox}>
                        <input
                          type="checkbox"
                          onClick={() => {
                            selectMultiItem({
                              title: item.title,
                              item: checkData,
                            });
                          }}
                          readOnly
                        />
                        <span />
                      </div>

                      <div style={{ marginLeft: "10px" }}>{checkData}</div>
                    </div>
                  );
                })}
              </div>
            )}
            {item.type === "objects" && (
              <div
                style={{
                  marginTop: "10px",
                }}
              >
                {(item.checkObject || []).map((objectData, objectIndex) => {
                  return (
                    <div
                      key={objectIndex}
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className={styles.radio}>
                            <input
                              type="checkbox"
                              onClick={() => {
                                setPramsCompanyFormData((prev) =>
                                  prev.map((prevItem, prevIndex) =>
                                    prevIndex === index
                                      ? {
                                          ...prevItem,
                                          content:
                                            objectData.form_type !== "checkbox"
                                              ? objectData.form_title + ","
                                              : objectData.form_title,
                                        }
                                      : prevItem,
                                  ),
                                );
                              }}
                              checked={
                                item.content?.split(",")[0] ===
                                objectData.form_title
                              }
                              readOnly
                            />
                            <span />
                          </div>

                          <div style={{ marginLeft: "10px" }}>
                            {objectData.form_title}
                          </div>
                        </div>
                        <div>
                          {objectData.form_type === "date" && (
                            <input
                              type="date"
                              min={tomorrow}
                              className={styles.objectInput}
                              onChange={(e) => {
                                checkToBeforeToday(e);

                                updateFormData({
                                  value: e.target.value,
                                  formTitle: objectData.form_title,
                                  index,
                                });
                              }}
                            />
                          )}
                          {objectData.form_type === "string" && (
                            <input
                              type="text"
                              className={styles.objectInput}
                              placeholder={objectData.form_placeholder}
                              onChange={(e) =>
                                updateFormData({
                                  value: e.target.value,
                                  formTitle: objectData.form_title,
                                  index,
                                })
                              }
                            />
                          )}
                          {objectData.form_type === "time" && (
                            <input
                              type="time"
                              className={styles.objectInput}
                              onChange={(e) =>
                                updateFormData({
                                  value: e.target.value,
                                  formTitle: objectData.form_title,
                                  index,
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
